import {type DataTestAttrs} from '@benchling/js-test-utils';
import React, {useState} from 'react';

import {
  CardSectionEmptyState,
  CardSectionMessageRow,
  CardSectionRowList,
  CardSectionRowProps,
} from '../CardSection';
import {
  HOMEPAGE_SECTION_TEST_COMPONENT,
  INITIAL_ROWS_TO_DISPLAY,
  MAX_ROWS_TO_DISPLAY,
} from '../HomepageConstants';
import {getMyWorkEmptyState} from '../HomepageEmptyStates';
import {MyWorkCategory} from './MyWorkConstants';

export interface MyWorkRowsListProps {
  rows: Array<CardSectionRowProps>;
  emptyMessageDataTestAttrs: DataTestAttrs;
  category: MyWorkCategory;
  totalCount: number;
}

export function MyWorkRowsList({
  rows,
  emptyMessageDataTestAttrs,
  category,
  totalCount,
}: MyWorkRowsListProps): JSX.Element {
  const [showMore, setShowMore] = useState(false);
  const maxRows = Math.max(MAX_ROWS_TO_DISPLAY, rows.length);
  const visibleRows = rows.slice(0, showMore ? maxRows : INITIAL_ROWS_TO_DISPLAY);
  const emptyState = getMyWorkEmptyState(category, totalCount);

  return (
    <>
      {rows.length === 0 ? (
        <CardSectionEmptyState {...emptyState} dataTestAttrs={emptyMessageDataTestAttrs} />
      ) : (
        <CardSectionRowList
          rows={visibleRows}
          rowDataTestAttrs={{
            component: HOMEPAGE_SECTION_TEST_COMPONENT.MY_WORK,
            element: `${category}Row`,
          }}
        />
      )}
      {rows.length > INITIAL_ROWS_TO_DISPLAY && (
        <CardSectionMessageRow
          message={showMore ? 'Show less' : 'Show more'}
          onClick={() => {
            setShowMore(!showMore);
          }}
          dataTestAttrs={{component: HOMEPAGE_SECTION_TEST_COMPONENT.MY_WORK, element: 'showMoreButton'}}
        />
      )}
    </>
  );
}
